import React from 'react';
import { Form, Input, Select } from '@tesla/react-context-form';
import { Component } from 'react';
import { InitialState } from '../../data/initialState';
import { connect } from 'react-redux';

class GB extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;        
        const { countryList, email, firstName, lastName, phone, zip, showECheckbox, values, form } = props;
        const Tesla = window.Tesla || {};
        let getUpdate = "Tesla Updates";
        if (typeof form.getUpdates !== "undefined") {
          getUpdate = form.getUpdates.replace("Tesla Updates", "<a href='/en_GB/about/legal#tesla-updates'>Tesla Updates</a>")
        }

        return (
            <div className="form-container en-us">
                <Form initialValues={values}>
                    <div className="tds-flex tds-layout-flex--two_columns">
                        <div className={"tds-flex-item " + firstName.class}>
                            <Input name="firstName" label={form.firstName} onChange={props.handleChange} id="edit-firstname-td" />
                            <p className="tds-form-item-feedback">{firstName.msg}</p>
                        </div>
                        <div className={"tds-flex-item " + lastName.class}>
                            <Input name="lastName" label={form.lastName} onChange={props.handleChange} id="edit-lastname-td" />
                            <p className="tds-form-item-feedback">{lastName.msg}</p>
                        </div>
                    </div>
                    <div className={"item-container " + email.class}>
                        <Input name="email" label={form.email} onChange={props.handleChange} id="edit-usermail-td" />
                        <p className="tds-form-item-feedback">{email.msg}</p>
                    </div>
                    <div className={"item-container " + phone.class}>
                        <Input name="phone" label={form.phoneNr} onChange={props.handleChange} id="edit-phonenumber-td" />
                        <p className="tds-form-item-feedback">{phone.msg}</p>
                    </div>
                    <div className={"item-container " + zip.class}>
                        <Input name="zip" label={form.zipCode} onChange={props.handleChange} id="edit-zipcode-td" />
                        <p className="tds-form-item-feedback">{zip.msg}</p>
                    </div>
                    {countryList == null ? null :
                      <Select name="country" label={form.country} onChange={props.handleChange} defaultValue={Tesla.country.toUpperCase()} autoscript="edit-countries-td">
                        {
                          Object.keys(countryList).map( (key, data) => 
                              <option key={key} value={key}>{countryList[key]}</option>
                          )
                        }
                      </Select>
                    }
                      <div className="tds-form-item">
                        <fieldset className="tds-form-fieldset" onChange={props.handleChange}>
                          <div className="tds-checkboxes">
                            {showECheckbox ?
                                <div className="tds-checkbox">    
                                  <input className="tds-checkbox-input" name="einterest" type="checkbox" id="interest-solar-powerwall" defaultChecked />
                                  <label className="tds-label tds-label--checkbox" htmlFor="interest-solar-powerwall">      
                                    <span className="tds-label-title">{form.interestedSolarPowerwall}</span>      
                                  </label>  
                                </div>
                            : null}
                            <div className="tds-checkbox">    
                              <input className="tds-checkbox-input" name="getUpdates" type="checkbox" id="get-updates" defaultChecked={values.getUpdates} />
                              <label className="tds-label tds-label--checkbox" htmlFor="get-updates">      
                                <span className="tds-label-title" dangerouslySetInnerHTML={{__html: getUpdate}}></span>
                              </label>  
                            </div>
                          </div>
                        </fieldset> 
                      </div>
                </Form>
            </div>
        )
    }
}

GB.defaultProps = InitialState().formsSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        firstName: _state.formsSection.validation.firstName,
        email: _state.formsSection.validation.email,
        lastName: _state.formsSection.validation.lastName,
        phone: _state.formsSection.validation.phone,
        zip: _state.formsSection.validation.zip
    }
}

const GBForm = connect(
    mapStateToProps
)(GB)

export default GBForm
